import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { NotificationService } from '@/services/notification-service';

export const useNotifications = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Check for notifications on page load
      NotificationService.schedulePeriodicNotifications(user.id);

      // Set up periodic checking (every 10 minutes)
      const interval = setInterval(() => {
        NotificationService.schedulePeriodicNotifications(user.id);
      }, 10 * 60 * 1000); // 10 minutes

      return () => clearInterval(interval);
    }
  }, [user]);

  return null;
};
